// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2541":"387d2033","3850":"a50eb87b","6066":"71f1e150","6146":"217f785c"}[chunkId] + ".chunk.css";
};